// extracted by mini-css-extract-plugin
export default {"PendingCTA":"companyDashboardParent_PendingCTA__vYW8S","PendingDone":"companyDashboardParent_PendingDone__iaJID"};